<template>
  <transition name="m-sheet">
    <div class="m-sheet__mask" @click.self="$emit('close')">
      <div class="m-sheet">
        <header class="m-sheet__head">
          <span class="m-sheet__title">{{ title }}</span>
          <button class="m-sheet__close" @click="$emit('close')" :aria-label="$t('returns.scan.close')">
            <i class="material-icons">close</i>
          </button>
        </header>
        <div class="m-sheet__body">
          <slot></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
// Bottom-Sheet fuer den Mobilbereich - der bewusst vue-material-freie Ersatz fuer Modal.vue.
export default {
  name: "MSheet",
  props: {
    title: { type: String, default: "" },
  },
};
</script>

<style lang="scss" scoped>
.m-sheet__mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 40;
  display: flex;
  align-items: flex-end;
}

.m-sheet {
  background: #fff;
  width: 100%;
  max-height: 85vh;
  border-radius: 14px 14px 0 0;
  display: flex;
  flex-direction: column;
  padding-bottom: env(safe-area-inset-bottom);

  &__head {
    display: flex;
    align-items: center;
    padding: 12px 8px 12px 16px;
    border-bottom: 1px solid #eee;
  }

  &__title {
    flex: 1;
    font-size: 16px;
    font-weight: 500;
  }

  &__close {
    width: 44px;
    height: 44px;
    border: 0;
    background: none;
    color: #757575;
    cursor: pointer;
  }

  &__body {
    overflow-y: auto;
    padding: 12px 16px 16px;
  }
}

.m-sheet-enter-active,
.m-sheet-leave-active {
  transition: opacity 0.18s;
}
.m-sheet-enter,
.m-sheet-leave-to {
  opacity: 0;
}
</style>
